import {useState,useEffect} from "react"
import { useNavigate, useParams } from "react-router-dom"
import SideBar from "../components/SideBar"
import{useSelector,useDispatch} from "react-redux"
import { fetchDetailMovie } from "../store/actions"
import CastCard from "../components/CastCard"


export default function DetailPage(){
    const dispatch= useDispatch()
    const navigate= useNavigate()
    const{detailId}= useParams()
   const {detailMovie}= useSelector((state)=>state.movie)

    useEffect(()=>{
        dispatch(fetchDetailMovie(detailId))
    },[])

    
    return(
        <div>
            <SideBar/>
            <div className="justify-end text-center items-center flex pr-20 pt-10 pb-10 rounded-lg">
                <div className="bg-gray-800 rounded-lg pt-10 pb-20 h-auto" style={{width:"1000px"}}>
                    <div className="justify-center items-center flex">
                        <img src={detailMovie.imgUrl} alt="" style={{width: "200px", height: "300px"}}/>
                    </div>
                    <div className="text-white pt-5">
                    <h1>Title:</h1>
                        <h1>{detailMovie.title}</h1>
                    </div>
                    <div className="text-white whitespace-normal pt-5">
                    <h1>Synopsis:</h1>
                        <h1>{detailMovie.synopsis}</h1>
                    </div>
                    <div className="text-white pt-5">
                        <h1>Rating:</h1>
                        <h1>{detailMovie.rating}</h1>
                    </div>
                    <div className="text-white pt-5">
                        <h1>Genre:</h1>
                        <h1>{detailMovie?.Genre?.name}</h1>
                    </div>
                    <div className="text-white justify-center items-center flex pt-5">
                        <h1>Trailer:</h1>
                    </div>
                    <div className="text-white self-center justify-center items-center flex flex-col pt-5">
                    <iframe width="500" height="250" src={detailMovie.trailerUrl} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                        <h1 className="pt-5" style={{fontSize: "20pt"}}>Cast</h1>
                    <div className="text-white justify-center items-center flex pt-5">
                    <div className="grid grid-cols-5 justify-center items-center">
                   {detailMovie?.Casts?.map((cast)=>
                   <CastCard key={cast.id} cast={cast}/>
                     )}
                     </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}